import { analytics } from '@/services/Analytics'
import { getGrowthbook } from './utils'

const growthbook = getGrowthbook({}, analytics.track)

export { growthbook }
